import { initComponentStore } from "@/utils/mobx";
import { appStore } from "@/app_store";
import { ApiServerError } from "@/utils/api";


export class SignUpSectionStore {
    email: string = "";
    password: string = "";
    fullName: string = "";
    error: string | null = null;
    isLoading: boolean = false;

    constructor() {
        initComponentStore(this);
    }

    setEmail(value: string) {
        this.email = value;
        this.error = null;
    }

    setPassword(value: string) {
        this.password = value;
        this.error = null;
    }

    setFullName(value: string) {
        this.fullName = value;
        this.error = null;
    }

    async submit() {
        if (!this.email || !this.password) {
            this.error = "Please fill in all fields.";
            return;
        }
        if (!this.fullName) {
            this.error = "Please enter your name.";
            return;
        }
        this.isLoading = true;
        this.error = null;
        try {
            await appStore.account.signUp(this.email, this.password, this.fullName);
        } catch (e) {
            if (e instanceof ApiServerError) {
                this.error = e.message;
            } else {
                this.error = "Connection error. Please try again.";
            }
        } finally {
            this.isLoading = false;
        }
    }
}
